import { FC, useEffect, useRef } from "react";
import { io } from "socket.io-client";
import SocketContext from "./socketContext";
import { backendUrl } from "config";
import { useAppSelector } from "store";
import { useQueryClient } from "@tanstack/react-query";
interface SocketContextProps {
  children: JSX.Element;
}

const SocketProvider: FC<SocketContextProps> = ({ children }) => {
  const { accessToken } = useAppSelector((state) => state.auth);
  const offsetNewOrder = useAppSelector(state => state.order.receiveOrder.offset);
  const limitNewOrder = useAppSelector(state => state.order.receiveOrder.limit);
  const queryClient = useQueryClient();

  const socket = useRef(
    io(backendUrl, {
      transports: ["websocket"],
      auth: {
        token: `${accessToken}`,
      },
    })
  );

  useEffect(() => {
    socket.current.on("connect", () => {
      console.log("SocketIO: Connected and authenticated");
    });

    socket.current.on("error", (msg: string) => {
      console.error("SocketIO: Error", msg);
    });

    socket.current.on("reload", (msg: string) => {
      queryClient.refetchQueries({ queryKey: ["getOrderproductskuNewOrder"], type: 'all' });
      queryClient.refetchQueries({ queryKey: ["waitingShip"], type: 'all' });
      queryClient.refetchQueries({ queryKey: ["orderComplete"], type: 'all' });
      queryClient.refetchQueries({ queryKey: ["orderCancel"], type: 'all' });
      queryClient.refetchQueries({ queryKey: ["pendingsku"], type: 'all' });
      queryClient.refetchQueries({ queryKey: ["agentsList"], type: 'all' });
      queryClient.refetchQueries({ queryKey: ["getNotificationList_20"], type: 'all' });
      console.log("emit: ", msg);
      console.log("SocketIO: Reload", msg);
    });

    socket.current.on("private-message", (msg: string) => {
      console.log("SocketIO: private-message", msg);
    });

    socket.current.on("chat_message", (msg: any) => {
      console.log("SocketIO: chat_message", msg);
    });

    socket.current.on("disconnect", (reason: string) => {
      console.log("SocketIO: Disconnected", reason);
    });

    return () => {
      // socket.current.disconnect();
    };
  }, []);

  return (
    <SocketContext.Provider value={{ socket: socket.current }}>
      {children}
    </SocketContext.Provider>
  );
};

export default SocketProvider;

// socket.current.on("reload", (msg: string) => {
//   queryClient.invalidateQueries("newOrders");
//   queryClient.invalidateQueries("waitingShip");
//   queryClient.invalidateQueries("orderComplete");
//   queryClient.invalidateQueries("orderCancel");
//   queryClient.invalidateQueries("pendingsku");
//   queryClient.invalidateQueries("getNotificationList_20");
//   console.log("emit: ", msg);
// });
